import type { ReactNode } from 'react';

import type { ChartType } from '../schema.ts';
import type { ChartRendererProps } from '../types.ts';
import { BubbleChartRenderer } from './BubbleChartRenderer.tsx';
import { CartesianChartRenderer } from './CartesianChartRenderer.tsx';
import { DonutChartRenderer } from './DonutChartRenderer.tsx';
import { FunnelChartRenderer } from './FunnelChartRenderer.tsx';
import { HeatmapRenderer } from './HeatmapRenderer.tsx';
import { PieChartRenderer } from './PieChartRenderer.tsx';
import { RadarChartRenderer } from './RadarChartRenderer.tsx';
import { RadialBarChartRenderer } from './RadialBarChartRenderer.tsx';
import { ScatterChartRenderer } from './ScatterChartRenderer.tsx';
import { SparklineRenderer } from './SparklineRenderer.tsx';

/**
 * Chart type to renderer mapping.
 */
export const CHART_RENDERERS: Record<ChartType, (props: ChartRendererProps) => ReactNode> = {
  bar: CartesianChartRenderer,
  line: CartesianChartRenderer,
  area: CartesianChartRenderer,
  composite: CartesianChartRenderer,
  pie: PieChartRenderer,
  donut: DonutChartRenderer,
  funnel: FunnelChartRenderer,
  radar: RadarChartRenderer,
  scatter: ScatterChartRenderer,
  bubble: BubbleChartRenderer,
  radialBar: RadialBarChartRenderer,
  sparkline: SparklineRenderer,
  heatmap: HeatmapRenderer,
};
